export const LOCALE = 'locale';

export const DEFAULT_LOCALE = 'uk';
